import { useMutation } from "@apollo/client";

import { MapEditorPlannerAreaPanel_PlannerVisitSetRequiredFieldworkersDocument } from "../../mutations.generated";
import { MapEditorPlannerAreaPanelDocument } from "../../queries.generated";

export function useUpdatePlannerVisitMutation() {
    const [mutate, result] = useMutation(MapEditorPlannerAreaPanel_PlannerVisitSetRequiredFieldworkersDocument, {
        refetchQueries: [MapEditorPlannerAreaPanelDocument],
    });

    const updatePlannerVisit = (plannerVisitId: string, requiredFieldworkers: number) =>
        mutate({
            variables: {
                input: {
                    plannerVisitId,
                    requiredFieldworkers,
                },
            },
        });

    return [updatePlannerVisit, result] as const;
}
